import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [meError, setMeError] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [period, setPeriodState] = useState(localStorage.getItem("ll_period") || "");

  const setPeriod = (p) => {
    localStorage.setItem("ll_period", p);
    setPeriodState(p);
  };

  const loadMe = useCallback(async () => {
    try {
      const r = await api.get("/me");
      setMe(r.data);
      setMeError(null);
    } catch (e) {
      setMeError(e);
    }
  }, [api]);

  const loadPeriods = useCallback(async () => {
    if (!me?.tenant_id || me.role === "client") return;
    const r = await api.get("/periods");
    setPeriods(r.data);
    setPeriodState((cur) => (cur && r.data.includes(cur) ? cur : r.data[0] || ""));
  }, [api, me?.tenant_id, me?.role]);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  useEffect(() => {
    loadPeriods();
  }, [loadPeriods]);

  return (
    <Ctx.Provider value={{ me, meError, loadMe, periods, period, setPeriod, loadPeriods }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
